import Vue from 'vue'
import i18n from '@/lang'
// import store from '@/store'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
// import API from '@/api'
// import MaintenanceRoutes from './maintenance'
import Meta from 'vue-meta'
import index from '@/components/Index'
import aliado from '@/components/aliado'
import empresa from '@/components/Empresa'
import Servicios from './servicios'
import NotFound from '@/components/NotFound'
import Blog from '@/components/Blog/Blog'
import Articules from '@/components/Blog/Articules'
import AdminLogin from '@/components/adminLogin'
import addBlog from '@/components/addBlog'
// import ipinfo from '@/store/modules/user'

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(i18n)
Vue.use(Meta)

export default new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/empresa',
            name: 'Empresa',
            component: empresa
        },
        {
            path: '/connect',
            beforeEnter(to, from, next) {
                window.open('https://grupogeos.trb.ai/wa/161qkL2', '_blank')
            }
        },
        {
            path: '/ventas',
            beforeEnter(to, from, next) {
                window.open('https://grupogeos.trb.ai/wa/161qkL2', '_blank')
            }
        },
        {
            path: '/conocimiento',
            beforeEnter(to, from, next) {
                window.open('https://conocimiento.grupogeos.co/', '_blank')
            }
        },
        {
            path: '/blog/:blog_id/:name',
            name: 'blog',
            component: Blog
        },
        {
            path: '/blog',
            name: 'blogArticule',
            component: Articules
        },
        {
            path: '/add-blog',
            name: 'add-blog',
            component: addBlog
        },
        {
            path: '/aliado',
            component: aliado
        },
        Servicios,
        {
            path: '*',
            name: '404',
            component: NotFound
        },
        {
            path: '/admin-login',
            name: 'admin-login',
            component: AdminLogin
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js